import {Inject, Injectable} from '@angular/core';
import {AccountModel} from "../models/account.model";
import {EntitiesChannel} from "../../../commons/angular/classes/entities-channel";

@Injectable({providedIn: 'root'})
export class AccountsChanelService extends EntitiesChannel<AccountModel> {

  constructor(@Inject('firebaseService') protected firebaseService) {
    super()
  }

  getChannelName(): String {
    return "accounts_changed";
  }

  getPartialChannelName(): String {
    return "accounts_partial_changed";
  }

  getCreateChannelName(): String {
    return "";
  }


}
